import Model from 'flarum/common/Model';
/**
 * An admin-defined extra field shown on the "new ticket" form.
 */
export default class TicketFormField extends Model {
  label = Model.attribute('label');
  name = Model.attribute('name');
  type = Model.attribute('type');
  options = Model.attribute('options');
  isRequired = Model.attribute('isRequired');
  isActive = Model.attribute('isActive');
  position = Model.attribute('position');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  updatedAt = Model.attribute('updatedAt', Model.transformDate);
  category = Model.hasOne('category');
}
flarum.reg.add('cengizkemec-support-tickets', 'common/models/TicketFormField', TicketFormField);